import { motion } from "framer-motion";

const PageLoader = () => {
  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-[#050B14]">
      <div className="relative">
        {/* Animated concentric rings */}
        <motion.div 
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className="w-16 h-16 rounded-3xl border-2 border-primary/20"
        />
        <motion.div 
          animate={{ rotate: -360 }}
          transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
          className="absolute inset-0 w-16 h-16 rounded-3xl border-2 border-primary/40 border-t-primary"
        />
        <div className="absolute inset-0 flex items-center justify-center">
           <div className="w-1 h-1 bg-primary rounded-full animate-pulse" />
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
